import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { getRoomDetails } from '@/redux/asyncThunks/room'
import { selectTeamStatuses } from '../../redux/selectors/charterSelectors'
import { PrepMonitorView } from '../../components/Professor/PrepMonitorView'

export default function CharterPrepMonitorPage() {
  const dispatch = useAppDispatch()
  const { roomId = '', memberId = '' } = useParams<{ roomId: string; memberId: string }>()
  const [searchParams] = useSearchParams()
  const teamId = searchParams.get('teamId') ?? ''

  const currentRoom = useAppSelector((s) => s.room.currentRoom)
  const teamStatuses = useAppSelector(selectTeamStatuses)

  // Hydrate currentRoom after a hard reload so the invite code can fall back
  // to it when the URL param is missing.
  useEffect(() => {
    if (roomId && currentRoom?.roomid !== roomId) {
      dispatch(getRoomDetails(roomId))
    }
  }, [dispatch, roomId, currentRoom?.roomid])

  const inviteCode = searchParams.get('inviteCode') || currentRoom?.invite_code || ''

  // Prefer the name encoded in the URL (survives hard reloads).
  // Fall back to Redux lookup, then bare memberId.
  const memberNameFromUrl = searchParams.get('memberName') ?? ''
  const memberName = memberNameFromUrl || (() => {
    for (const ts of teamStatuses) {
      const m = ts.members.find((m) => String(m.member_id) === memberId)
      if (m) return m.member_name || m.member_email
    }
    return memberId
  })()

  return (
    <div className='h-full w-full'>
      <PrepMonitorView
        memberId={memberId}
        memberName={memberName}
        roomId={roomId}
        inviteCode={inviteCode}
        teamId={teamId}
      />
    </div>
  )
}
